import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Button,
  Dimmer,
  Form,
  Grid,
  Header,
  Image,
  Loader,
  Message,
  Segment,
} from 'semantic-ui-react';
import { useStitchAuth } from './StitchAuth';

const LoginForm = (props) => {
  let location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState(false);
  const [errorType, setErrorType] = useState(null);
  const [inProcess, setInProcess] = useState(false);
  const { actions } = useStitchAuth();

  let history = useHistory();

  const handleSubmit = () => {
    setInProcess(true);
    setFormError(false);
    setErrorType(null);

    actions
      .handleB2CLogin(email, password)
      .then((res) => {
        if (!res) {
          setInProcess(false);
          setFormError(true);
          setErrorType('disabled');
          return;
        }
        let pathname = '/home/all-members';
        let search = '';
        if (location.state && location.state.from) {
          pathname = location.state.from.pathname || pathname;
          search = location.state.from.search || '';
        }
        history.replace({
          pathname,
          search,
        });
      })
      .catch((b2cError) => {
        console.error('B2C login failed', b2cError);
        setInProcess(false);
        setFormError(true);
        if (b2cError.message && b2cError.message.toLowerCase().includes('disabled')) {
          setErrorType('disabled');
        } else {
          setErrorType('error');
        }
      });
  };

  return (
    <div
      style={{
        backgroundImage: 'url("/images/astrana_gradient_2.png")',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <Dimmer inverted active={inProcess}>
        <Loader />
      </Dimmer>
      <Grid
        textAlign="center"
        style={{
          height: '100vh',
          margin: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
        }}
        verticalAlign="middle"
      >
        <Grid.Column
          style={{
            maxWidth: 450,
            backgroundColor: '#fff',
            padding: '3em',
          }}
        >
          <Header
            as="h2"
            icon
            textAlign="center"
            style={{ marginBottom: '1.5em' }}
          >
            <Image
              src={'/logos/astranalogo.png'}
              style={{
                margin: '0.7em',
                height: '4em',
                width: 'auto',
              }}
            />
            <Header.Content style={{ fontWeight: 300 }}>
              Log-in to your account
            </Header.Content>
          </Header>

          <Form size="large" error={!!formError}>
            <Segment style={{ border: '0', boxShadow: '0 0 0 0' }}>
              {formError && errorType === 'error' && (
                <Message
                  error
                  header="Invalid Username or Password"
                  content="Please check your login credentials."
                />
              )}
              {formError && errorType === 'disabled' && (
                <Message
                  error
                  header="Account Disabled"
                  content="Please contact your administrator."
                />
              )}
              <Form.Input
                fluid
                icon="user"
                iconPosition="left"
                placeholder="E-mail address"
                value={email}
                onChange={(event) =>
                  setEmail(
                    event.target.value
                      .toLowerCase()
                      .replace(/\s/g, ''),
                  )
                }
              />
              <Form.Input
                fluid
                icon="lock"
                iconPosition="left"
                placeholder="Password"
                type="password"
                value={password}
                onChange={(event) =>
                  setPassword(event.target.value.replace(/\s/g, ''))
                }
              />
              <Button
                //style={{backgroundColor: "#335eea", color: "#fff"}}
                //color="green"
                primary
                fluid
                size="large"
                onClick={handleSubmit}
              >
                Log-in
              </Button>
            </Segment>
          </Form>
          <p style={{ marginTop: '2em' }} className="grey text">
            Forgot your password?{' '}
            <a href="/passwordresetsend">Reset your password.</a>
          </p>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default LoginForm;
